import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";

const Breadcrumb = ({ items, disableMaxWidth = false }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        paddingBottom: isMobile ? "16px" : "0px",
        paddingTop: isMobile ? "0px" : "26px",
        width: "94.44%",
        maxWidth: disableMaxWidth ? "100%" : "1440px",
        margin: "0 auto",
        flexWrap: "wrap",
      }}
    >
      {items.map((item, index) => (
        <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
          {index > 0 && (
            <Typography
              sx={{
                color: "#1D1D1B",
                fontSize: "18px",
                fontWeight: 500,
                // fontFamily: "Red Hat Display",
                fontStyle: "Medium",
                lineHeight: "100%",
                letterSpacing: "-1%",
                verticalAlign: "middle",
                marginLeft: "6px",
                marginRight: "6px",
              }}
            >
              &gt;
            </Typography>
          )}
          {index === items.length - 1 ? (
            // Last item - not clickable
            <Typography
              sx={{
                color: "#1D1D1B",
                fontSize: "14px",
                fontWeight: 600,
                // fontFamily: "Red Hat Display",
                fontStyle: "SemiBold",
                lineHeight: "100%",
                letterSpacing: "-1%",
                verticalAlign: "middle",
                cursor: "default",
              }}
            >
              {item.label}
            </Typography>
          ) : (
            // Clickable items
            <Link
              component="button"
              onClick={() => handleClick(item.path)}
              sx={{
                color: "#686866",
                fontSize: "14px",
                fontWeight: 500,
                // fontFamily: "Red Hat Display",
                fontStyle: "Medium",
                lineHeight: "100%",
                letterSpacing: "-1%",
                textAlign: "center",
                verticalAlign: "middle",
                textDecoration: "none",
                cursor: "pointer",
                "&:hover": {
                  color: "#1D1D1B",
                },
                border: "none",
                background: "none",
                padding: 0,
              }}
            >
              {item.label}
            </Link>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default Breadcrumb;
